import { showInputError } from "../../../shared/input-handler";
import { Notifications } from "../../../notifications";
export class TimeSchedule {
    constructor(form) {
        this.form = form;
        this.startTime = {};
        this.endTime = {};
        this.findStartTimes();
        this.findEndTime();
        this.ensureHasSameDaysIds();
    }
    ensureHasSameDaysIds() {
        const startTimesDaysIds = Object.keys(this.startTime);
        const endTimesDaysIds = Object.keys(this.endTime);
        if (startTimesDaysIds.length !== endTimesDaysIds.length) {
            return false;
        }
        startTimesDaysIds.sort();
        endTimesDaysIds.sort();
        for (let i = 0; i < startTimesDaysIds.length; i++) {
            if (startTimesDaysIds[i] !== endTimesDaysIds[i]) {
                return false;
            }
        }
        return true;
    }
    findEndTime() {
        const entTimes = this.form.querySelectorAll(TimeSchedule.endTimeSelector);
        entTimes.forEach((endTime) => {
            const { timeGroup } = endTime.dataset;
            this.endTime[timeGroup] = endTime;
        });
        if (Object.keys(this.endTime).length === 0) {
            throw new Error(`Element with ${TimeSchedule._startTimeSelector} not found`);
        }
        // Lanza un error si el número de startTime no coincide con el de endTime
        if (Object.keys(this.startTime).length !== Object.keys(this.endTime).length) {
            throw new Error(`The number of start times doesn't match the number of end times`);
        }
    }
    findStartTimes() {
        const startTimes = this.form.querySelectorAll(TimeSchedule._startTimeSelector);
        startTimes.forEach((startTime) => {
            const { timeGroup } = startTime.dataset;
            this.startTime[timeGroup] = startTime;
        });
        if (Object.keys(this.startTime).length === 0) {
            throw new Error(`Element with ${TimeSchedule._startTimeSelector} not found`);
        }
    }
    static toInt(time) {
        const timeParts = time.split(":");
        return parseInt(timeParts[0]) * 100 + parseInt(timeParts[1]);
    }
    addToFormData(formData) {
        Object.keys(this.startTime).forEach((timeGroup) => {
            formData.append(this.startTime[timeGroup].name, this.startTime[timeGroup].value);
            formData.append(this.endTime[timeGroup].name, this.endTime[timeGroup].value);
        });
    }
    validate() {
        return this.hasAtLeastOneSelected() && this.areInCorrectOrder();
    }
    areInCorrectOrder() {
        let isValid = true;
        Object.keys(this.startTime).forEach((timeGroup) => {
            if (this.startTime[timeGroup].value === "" &&
                this.endTime[timeGroup].value === "") {
                return;
            }
            if (TimeSchedule.toInt(this.startTime[timeGroup].value) >=
                TimeSchedule.toInt(this.endTime[timeGroup].value)) {
                showInputError(this.endTime[timeGroup], this.errorGreaterThan);
                isValid = false;
            }
        });
        return isValid;
    }
    hasAtLeastOneSelected() {
        let isValid = false;
        Object.keys(this.startTime).forEach((timeGroup) => {
            if (this.startTime[timeGroup].value !== "" &&
                this.endTime[timeGroup].value !== "") {
                isValid = true;
            }
        });
        if (!isValid) {
            Notifications.error(requiredField);
        }
        return isValid;
    }
}
TimeSchedule._startTimeSelector = ".js-start-time";
TimeSchedule.endTimeSelector = ".js-end-time";
